import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import './AllPackagesPage.css';

const AllPackagesPage = () => {
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const [{ data: regionsData }, { data: itinsData }] = await Promise.all([
        supabase
          .from('navbar_config')
          .select('region, color, fa_icon, active, display_order')
          .eq('active', true)
          .order('display_order'),
        supabase
          .from('itineraries')
          .select('destination, region, slug, active')
          .eq('active', true)
          .order('destination'),
      ]);

      if (regionsData) {
        const merged = regionsData.map(r => ({
          ...r,
          destinations: (itinsData || [])
            .filter(i => i.region === r.region)
            .map(i => i.destination),
        }));
        setRegions(merged);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const openItinerary = (dest) => {
    navigate(`/itinerary/${encodeURIComponent(dest)}`);
  };

  const filtered = search.trim()
    ? regions
        .map(r => ({
          ...r,
          destinations: r.destinations.filter(d =>
            d.toLowerCase().includes(search.toLowerCase())
          ),
        }))
        .filter(r => r.destinations.length > 0)
    : regions;

  return (
    <div className="all-packages-page">
      {/* Hero Banner */}
      <div className="ap-hero">
        <div className="ap-hero-content">
          <span className="ap-hero-label">
            <i className="fa-solid fa-earth-asia"></i> All Holiday Packages
          </span>
          <h1 className="ap-hero-title">Explore the World with Us</h1>
          <p className="ap-hero-sub">
            250+ handcrafted itineraries across every corner of the globe — click any destination to
            view its full day-by-day itinerary.
          </p>
          {/* Search */}
          <div className="ap-search-wrap">
            <i className="fa-solid fa-magnifying-glass ap-search-icon"></i>
            <input
              type="text"
              className="ap-search-input"
              placeholder="Search destinations... (e.g. Dubai, Goa, Paris)"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            {search && (
              <button className="ap-search-clear" onClick={() => setSearch('')}>
                <i className="fa-solid fa-xmark"></i>
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="ap-body">
        {loading ? (
          <div className="ap-loading">
            <i className="fa-solid fa-circle-notch fa-spin"></i>
            <span>Loading packages…</span>
          </div>
        ) : filtered.length === 0 ? (
          <div className="ap-empty">
            <i className="fa-solid fa-map-location-dot"></i>
            <p>No destinations found for "<strong>{search}</strong>"</p>
          </div>
        ) : (
          <div className="ap-regions">
            {filtered.map(region => (
              <div className="ap-region-block" key={region.region}>
                {/* Region Header */}
                <div className="ap-region-header" style={{ borderColor: region.color }}>
                  <div className="ap-region-icon-wrap" style={{ background: `${region.color}18` }}>
                    <i className={`${region.fa_icon} ap-region-fa`} style={{ color: region.color }}></i>
                  </div>
                  <h2 className="ap-region-name" style={{ color: region.color }}>
                    {region.region}
                  </h2>
                  <span className="ap-region-count" style={{ background: `${region.color}18`, color: region.color }}>
                    {region.destinations.length} packages
                  </span>
                </div>

                {/* Destination Tiles */}
                <div className="ap-dest-grid">
                  {region.destinations.map((dest, i) => (
                    <button
                      key={i}
                      className="ap-dest-card"
                      onClick={() => openItinerary(dest)}
                      style={{ '--region-color': region.color }}
                    >
                      <span className="ap-dest-name">{dest}</span>
                      <span className="ap-dest-arrow">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AllPackagesPage;
